<template>
  <div class="ff-context-menu">
    <ff-button
      :data-ref="trigger"
      :text="text"
      :action="()=>{return}"
      :ref="``"
      class="trigger"
      :icon="iconRender"
      :pattern="2"
      :class="{
        'is-hidden': show,
      }"
    />
    <ff-menu
      class="menu"
      :items="items"
      :class="{'is-active': show}"
      :style="style"
      @action="bubbleAction"
    />
  </div>
</template>

<script>
import FFMenu from './FFMenu'
import FFButton from './FFButton'
const MENU_WIDTH = 256

export default {
  name: 'ff-context-menu',
  components: {
    'ff-menu': FFMenu,
    'ff-button': FFButton
  },
  props: [
    'text',
    'icon',
    'items'
  ],
  data () {
    return {
      deactivated: false,
      show: false,
      menu_top: 10,
      menu_right: 10,
      trigger: 0
    }
  },
  computed: {
    style () {
      let s = {}
      s.top = this.menu_top
      s.right = this.menu_right
      return s
    },
    iconRender () {
      if (this.text) return false
      return 'overflow'
    }
  },
  methods: {
    toggleMenu (e) {
      let t = e.target.attributes['data-ref']
      if (t && t.nodeValue === this.trigger) {
        return this.showMenu(e)
      }
      this.show = false
    },
    showMenu (e) {
      this.$emit('event', e);
      let w = window.innerWidth
      let r = w - e.clientX
      this.menu_top = `${e.pageY}px`

      if (e.clientX < MENU_WIDTH) {
        r = r - MENU_WIDTH
      }

      this.menu_right =`${r}px`
      this.show = true
    },
    bubbleAction (item) {
      this.$emit('action', item)
    }
  },
  mounted () {
    this.trigger = `trigger-${Math.random().toString(16).slice(2)}`
    document.addEventListener('click', this.toggleMenu)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.toggleMenu)
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  @keyframes show {
    0% {
      opacity: 0;
      transform: translate3d(0, .5rem, 0);
    }
    100% {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .trigger {
    margin: 0;
    opacity: 1;
    transition: .1s ease all;

    &.is-hidden {
      opacity: 0;
      transition: .1s ease all;
    }
  }

  .menu {
    position: absolute;
    display: none;

    &.is-active {
      display: block;
      animation: show .12s ease;
    }
  }
</style>
